import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Quotes, Trophy } from "@phosphor-icons/react";
import { api } from "@/lib/api";

export default function MoraleCard() {
  const [m, setM] = useState(null);
  useEffect(() => { api.get("/morale/today").then(r => setM(r.data)).catch(() => {}); }, []);
  if (!m) return null;
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-testid="morale-card">
      <div className="relative overflow-hidden border-2 border-slate-900 bg-slate-900 text-white p-4">
        <Quotes weight="fill" size={56} className="absolute -right-2 -top-2 text-white/10"/>
        <div className="text-[9px] font-black uppercase tracking-widest text-cyan-300">Today's fuel</div>
        <div className="mt-1 text-base md:text-lg font-black leading-snug" data-testid="morale-quote">“{m.quote.text}”</div>
        <div className="mt-1 text-[11px] text-slate-300">— {m.quote.by}</div>
      </div>
      <div className="relative overflow-hidden border-2 border-amber-400 bg-amber-50 p-4">
        <Trophy weight="fill" size={56} className="absolute -right-2 -top-2 text-amber-300/40"/>
        <div className="text-[9px] font-black uppercase tracking-widest text-amber-800">Win of the day</div>
        <div className="mt-1 text-sm font-bold text-slate-900 leading-snug" data-testid="morale-win">{m.win.text}</div>
        {m.win.job_id && (
          <Link to={`/admin/jobs/${m.win.job_id}`} className="mt-1 inline-block text-[10px] font-black uppercase tracking-widest text-amber-800 hover:underline" data-testid="morale-win-link">
            See the job →
          </Link>
        )}
      </div>
    </div>
  );
}
